import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    homework_id: number;
}

export interface IPresentationScoreStat {
    avg_score: number;
    score_num: number;
}

const DEFAULT_STAT: IPresentationScoreStat = { avg_score: 0, score_num: 0 };

export const getPresentationScoreStat = (data: IInput): Promise<IPresentationScoreStat> => {
    return fetchData(Api.GET_PRESENTATION_SCORE_STAT, data, { silent: true })
        .then((res: IResponse<IPresentationScoreStat>) => {
            if (res.error_code) {
                return DEFAULT_STAT;
            }
            return res.data;
        })
        .catch(() => DEFAULT_STAT);
};
